/**
 * Environment detection utilities
 */

import { Region } from '@/utils/translations/types/TypeLanguagesAndLocales';

/**
 * Check if code is running on the server (Node.js) vs client (browser)
 * @returns true if running server-side, false if running client-side
 */
export function isServerSide(): boolean {
  return typeof window === 'undefined';
}

/**
 * Check if sessionStorage is available and functional
 * @returns true if sessionStorage can be used, false otherwise
 */
export function isSessionStorageAvailable(): boolean {
  if (typeof Storage === 'undefined') return false;

  try {
    const key = '__test_storage__';
    sessionStorage.setItem(key, 'test');
    sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

/**
 * Determine which region we are in for regional based features
 */
export function getStoreRegion(): Region {
  const region = process.env.NEXT_PUBLIC_REGION;

  switch (region) {
    case 'EU':
      return Region.EU;
    case 'UK':
      return Region.UK;
    case 'AU':
      return Region.AU;
    case 'US':
    default:
      return Region.US;
  }
}

export function isEuStore(): boolean {
  const region = getStoreRegion();
  return region === Region.EU;
}

export function isUkStore(): boolean {
  const region = getStoreRegion();
  return region === Region.UK;
}

export function isAuStore(): boolean {
  const region = getStoreRegion();
  return region === Region.AU;
}

export function isUsStore(): boolean {
  const region = getStoreRegion();
  return region === Region.US;
}
